import React, { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "./componants/Nav-section/DashboardLayout";
import Loader from "./componants/Loader";
import FallbackLoader from "./componants/FallbackLoader";

// Lazy-loaded components
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const Password = lazy(() => import("./pages/Password"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const RegisterWithGoogle = lazy(() => import("./pages/RegisterWithGoogle"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const AdminLogin = lazy(() => import("./superAdminAuth/Login"));
const AdminForgotPassword = lazy(() =>
  import("./superAdminAuth/ForgotPassword")
);
const AdminRegisterWithGoogle = lazy(() =>
  import("./superAdminAuth/RegisterWithGoogle")
);
const AdminRegister = lazy(() => import("./superAdminAuth/Register"));
const AdminPassword = lazy(() => import("./superAdminAuth/Password"));

const LogInRoutes = () => {
  const routes = useRoutes([
    {
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to='/dashboard' />, index: true },
        { path: "/dashboard", element: <Dashboard /> },
      ],
    },
    { path: "/register", element: <Register /> },
    { path: "/password", element: <Password /> },
    { path: "/newpassword", element: <ForgotPassword /> },
    { path: "/register-with-google", element: <RegisterWithGoogle /> },
    {
      path: "/login",
      element: (
        <Suspense fallback={<FallbackLoader />}>
          <Login />
        </Suspense>
      ),
    },
    {
      path: "/admin",
      element: (
        <Suspense fallback={<FallbackLoader />}>
          <AdminLogin />
        </Suspense>
      ),
    },
    {
      path: "/adminregister",
      element: (
        <Suspense fallback={<FallbackLoader />}>
          <AdminRegister />
        </Suspense>
      ),
    },
    {
      path: "/adminpassword",
      element: (
        <Suspense fallback={<FallbackLoader />}>
          <AdminPassword />
        </Suspense>
      ),
    },
    {
      path: "/adminforgotPassword",
      element: (
        <Suspense fallback={<FallbackLoader />}>
          <AdminForgotPassword />
        </Suspense>
      ),
    },
    {
      path: "/adminregister-with-google",
      element: (
        <Suspense fallback={<FallbackLoader />}>
          <AdminRegisterWithGoogle />
        </Suspense>
      ),
    },
  ]);

  return routes;
};

export default LogInRoutes;
